export const UPDATE_PSEUDONYM_REQUEST = 'UPDATE_PSEUDONYM_REQUEST';

export const updatePseudonymRequest = ( id, updateData ) => ({
    type: UPDATE_PSEUDONYM_REQUEST,
    payload: { id, updateData }
});
